import { MemberEligibilityInfo } from "@/App/types";
import { DateTime } from "luxon";
import { FC, useMemo } from "react";
import CignaLogo from "../Assets/cigna-logo.png";
import JudiHealthLogo from "../Assets/judi-health-logo-white.png";
import "./UnifiedCard.scss";

export const UnifiedCardFront: FC<{ readonly memberEligibilityInfo: MemberEligibilityInfo }> = ({ memberEligibilityInfo }) => {
  const cardPlanName = useMemo(() => {
    // return memberEligibilityInfo?.group?.group_name ?? memberEligibilityInfo?.medical_group?.name;
    return memberEligibilityInfo?.medical_plan_benefit?.name;
  }, [memberEligibilityInfo]);

  const cardGroupName = useMemo(() => {
    return memberEligibilityInfo?.plan?.name;
  }, [memberEligibilityInfo]);

  const cardMedicalGroupNumber = useMemo(() => {
    return memberEligibilityInfo?.plan?.client_id;
  }, [memberEligibilityInfo]);

  // TODO -- jank
  const cignaGroupNumber = "0254558";

  const cardEffectiveDate = useMemo(() => {
    const memberEffectiveDate = memberEligibilityInfo?.member?.effective_date;
    if (memberEffectiveDate) {
      return DateTime.fromISO(memberEffectiveDate).toUTC().toLocaleString(DateTime.DATE_SHORT);
    }
    return undefined;
  }, [memberEligibilityInfo]);

  const cardMemberName = useMemo(() => {
    const firstName = memberEligibilityInfo?.member?.first_name;
    const lastName = memberEligibilityInfo?.member?.last_name;
    if (firstName && lastName) {
      return `${firstName} ${lastName}`;
    }
    return firstName;
  }, [memberEligibilityInfo]);

  const cardMemberId = useMemo(() => {
    return memberEligibilityInfo?.member?.external_member_id;
  }, [memberEligibilityInfo]);

  const cardBinNumber = useMemo(() => {
    return memberEligibilityInfo?.plan?.bin_number;
  }, [memberEligibilityInfo]);

  const cardPCN = useMemo(() => {
    return memberEligibilityInfo?.plan?.processor_control_number;
  }, [memberEligibilityInfo]);

  const cardRxGroupNumber = useMemo(() => {
    // order of precedence group > plan account > plan
    if (memberEligibilityInfo.group.group_number) {
      return memberEligibilityInfo.group.group_number.split(",")[0];
    } else if (memberEligibilityInfo.plan_account.group_number) {
      return memberEligibilityInfo.plan_account.group_number.split(",")[0];
    } else {
      return memberEligibilityInfo.plan.group_number?.split(",")[0];
    }
  }, [memberEligibilityInfo]);

  return (
    <div className="card card-front">
      <div className="header">
        <img src={JudiHealthLogo} alt="Judi Health" className="logo" />
        <p className="plan-name">{cardPlanName}</p>
      </div>
      <div className="content">
        <div className="content-left">
          <div>
            <div>
              <span>Group Name: </span>
              <span>{cardGroupName}</span>
            </div>
            <div>
              <span>Group #: </span>
              <span>{cardMedicalGroupNumber}</span>
            </div>
          </div>

          <div>
            <div>
              <span>Cigna Group #: </span>
              <span>{cignaGroupNumber}</span>
            </div>
            <div>
              <span>Effective Date: </span>
              <span>{cardEffectiveDate}</span>
            </div>
          </div>

          <div>
            <div>
              <span>Member Name: </span>
              <span>{cardMemberName}</span>
            </div>
            <div>
              <span>ID Number: </span>
              <span>{cardMemberId}</span>
            </div>
          </div>
        </div>
        <div className="content-right">
          <div>
            <div>
              <span>RxBIN: </span>
              <span>{cardBinNumber}</span>
            </div>
            <div>
              <span>RxPCN: </span>
              <span>{cardPCN}</span>
            </div>
            <div>
              <span>RxGrp: </span>
              <span>{cardRxGroupNumber}</span>
            </div>
          </div>
          <img src={CignaLogo} alt="Cigna Logo" />
        </div>
      </div>
      <div className="footer">
        <p>Benefits and Claims Administered by Judi Health</p>
        <p>Member/Provider Payer Eligibility: 1-833-599-1020</p>
      </div>
    </div>
  );
};
